import { render, staticRenderFns } from "./gajotsavam.vue?vue&type=template&id=78dbe367&"
import script from "./gajotsavam.vue?vue&type=script&lang=js&"
export * from "./gajotsavam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports